import React, { type ReactElement, type ReactNode } from 'react';
import clsx from 'clsx';

type ColumnProps = {
  className?: string;
  colSpan?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12; // The Bootstrap column size (1-12)
  children: ReactNode | ReactNode[];
};

function Column({ className, colSpan = 3, children }: ColumnProps): ReactElement {
  return <div className={clsx(`col-md-${colSpan} pb-4`, className)}>{children}</div>;
}

type RowProps = {
  className?: string;
  children: ReactNode | ReactNode[];
};

function Row({ className, children }: RowProps): ReactElement {
  return <div className={clsx('row g-4 pb-3', className)}>{children}</div>;
}

type GridProps = {
  className?: string;
  children: ReactNode | ReactNode[];
};

function Grid({ className, children }: GridProps): ReactElement {
  return <div className={className}>{children}</div>;
}

export default Object.assign(Grid, {
  Row,
  Column
});
